import * as React from 'react';

const Check = ({ color = '#FFFFFF', ...props }) => (
  <svg width={18} height={13} stroke={color} strokeWidth={2} viewBox="0 0 18 13" {...props}>
    <polyline
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      points="17 1 6 12 1 7"
    />
  </svg>
);

export default Check;



// WEBPACK FOOTER //
// ./src/assets/images/icons/check.js